var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TestLogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210.582,
    height: 48,
    viewBox: "0 0 210.582 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 30.422,
    height: 13.998,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M50.527,68.4l.049-15.694A3.644,3.644,0,0,0,49.55,50.09L37.19,40.26l.039,15.758a3.1,3.1,0,0,0,1.051,2.639l12.242,9.736Z",
    transform: "translate(-18.847 -20.403)",
    fill: "#006aac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M39.32,33.789,54.6,30.213a3.639,3.639,0,0,1,2.782.409l12.36,9.83L54.378,43.959a3.1,3.1,0,0,1-2.811-.434L39.325,33.789Z",
    transform: "translate(-19.927 -15.254)",
    fill: "#01f0d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 19.122)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,42.439l15.28-3.576a3.639,3.639,0,0,1,2.782.409l12.36,9.83L15.058,52.609a3.1,3.1,0,0,1-2.811-.434Z",
    transform: "translate(0 -38.75)",
    fill: "#6dc2ee"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M50.107,28.143l.049-15.694A3.644,3.644,0,0,0,49.13,9.83L36.77,0l.039,15.758A3.089,3.089,0,0,0,37.865,18.4l12.247,9.741Z",
    transform: "translate(-18.634)",
    fill: "#0bd984"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 49.815,
    height: 48,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    transform: "translate(62.607 15.27)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3",
    d: "M147.873,31.94V37.5h-5.564V54.446h-5.756V37.5H130.99V31.94h16.878Z",
    transform: "translate(-130.99 -31.457)",
    fill: "#072635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4-2",
    "data-name": "Path 4",
    d: "M167.419,54.511q.806,1.961,3.6,1.963a4.1,4.1,0,0,0,2.925-1.125l3.857,2.7a8.314,8.314,0,0,1-6.91,2.989,8.962,8.962,0,0,1-6.54-2.4,8.111,8.111,0,0,1-2.461-6.062,8.3,8.3,0,0,1,8.552-8.518,7.816,7.816,0,0,1,5.948,2.412,8.929,8.929,0,0,1,2.121,8.035H167.419Zm-.064-3.694h6.17a2.853,2.853,0,0,0-3.023-2.249,3.011,3.011,0,0,0-3.152,2.249Z",
    transform: "translate(-146.65 -37.599)",
    fill: "#072635"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5-2",
    "data-name": "Path 5",
    d: "M207.537,61.047a8.485,8.485,0,1,1,0-16.967,8.483,8.483,0,0,1,4.326,1.125,7.861,7.861,0,0,1,3,3.023L210.3,50.862a2.951,2.951,0,0,0-2.8-1.573,3.019,3.019,0,0,0-2.249.917,3.558,3.558,0,0,0,0,4.725,3.027,3.027,0,0,0,2.249.917,2.87,2.87,0,0,0,2.8-1.608l4.562,2.634a7.836,7.836,0,0,1-3,3.053,8.483,8.483,0,0,1-4.326,1.125Z",
    transform: "translate(-165.451 -37.609)",
    fill: "#072635"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    d: "M244.44,37.918A5.559,5.559,0,0,1,248.7,39.7a7.267,7.267,0,0,1,1.657,5.129v9.613h-5.337V45.508a2.526,2.526,0,0,0-.661-1.894,2.4,2.4,0,0,0-1.751-.641,2.5,2.5,0,0,0-1.943.755,3.115,3.115,0,0,0-.691,2.17V54.45H234.64V31.94h5.337v8.035a5.089,5.089,0,0,1,4.469-2.057Z",
    transform: "translate(-183.518 -31.457)",
    fill: "#072635"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M275.219,71.608a3.26,3.26,0,0,1-2.4-.982,3.317,3.317,0,0,1,.015-4.725,3.283,3.283,0,0,1,2.377-.981,3.344,3.344,0,0,1,0,6.688Z",
    transform: "translate(-202.37 -48.17)",
    fill: "#0bd984"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M298.374,54.427A11.431,11.431,0,0,1,286.64,42.694a11.746,11.746,0,0,1,17.391-10.289,10.8,10.8,0,0,1,4.084,3.891l-4.982,2.861a4.6,4.6,0,0,0-1.914-1.879,6.367,6.367,0,0,0-7.2,1,6.038,6.038,0,0,0-1.657,4.419,6.038,6.038,0,0,0,1.657,4.419,6.367,6.367,0,0,0,7.2,1,4.561,4.561,0,0,0,1.914-1.914l4.982,2.9A10.633,10.633,0,0,1,304.051,53a11.549,11.549,0,0,1-5.672,1.43Z",
    transform: "translate(-209.871 -30.96)",
    fill: "#072635"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M345.028,44.524h5.337V60.6h-5.337v-1.48a5.663,5.663,0,0,1-4.562,1.928,6.937,6.937,0,0,1-5.386-2.427,8.755,8.755,0,0,1-2.17-6.057,8.755,8.755,0,0,1,2.17-6.057,6.93,6.93,0,0,1,5.386-2.427,5.656,5.656,0,0,1,4.562,1.928v-1.48ZM339.208,55.1a3.58,3.58,0,0,0,4.883,0,3.927,3.927,0,0,0,0-5.08,3.58,3.58,0,0,0-4.883,0,3.927,3.927,0,0,0,0,5.08Z",
    transform: "translate(-233.319 -37.609)",
    fill: "#072635"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M379.9,47.639a4.171,4.171,0,0,1,1.8-2.441,5.481,5.481,0,0,1,3.023-.868v5.914a4.628,4.628,0,0,0-3.329.676,3.453,3.453,0,0,0-1.494,3.152v6.654H374.56V44.651H379.9Z",
    transform: "translate(-254.427 -37.736)",
    fill: "#072635"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M402.379,54.511q.806,1.961,3.6,1.963A4.1,4.1,0,0,0,408.9,55.35l3.857,2.7a8.314,8.314,0,0,1-6.91,2.989,8.962,8.962,0,0,1-6.54-2.4,8.111,8.111,0,0,1-2.461-6.062A8.3,8.3,0,0,1,405.4,44.06a7.823,7.823,0,0,1,5.948,2.412,8.929,8.929,0,0,1,2.121,8.035H402.384Zm-.064-3.694h6.17a2.853,2.853,0,0,0-3.023-2.249,3.011,3.011,0,0,0-3.152,2.249Z",
    transform: "translate(-265.723 -37.599)",
    fill: "#072635"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogo);
export default __webpack_public_path__ + "static/media/ic_logo.88af223195d0f4c09a8c609cf21c6d07.svg";
export { ForwardRef as ReactComponent };